var React = require('react');

function MinusSmall (props) {
    return React.createElement("svg",props,React.createElement("line",{"strokeWidth":"2","strokeMiterlimit":"10","x1":"10","y1":"5","x2":"0","y2":"5"}));
}

MinusSmall.defaultProps = {"x":"0px","y":"0px","width":"10px","height":"10px","viewBox":"0 0 10 10","enableBackground":"new 0 0 10 10","xmlSpace":"preserve"};

module.exports = MinusSmall;

MinusSmall.default = MinusSmall;
